const storageKey = (lojaId) => `carrinhosAbandonadosVistoEm_${lojaId}`;

export function getAbandonedCartVistoEm(lojaId) {
	const key = storageKey(lojaId);
	let value = localStorage.getItem(key);
	if (!value) {
		value = new Date().toISOString();
		localStorage.setItem(key, value);
	}
	return value;
}

export function markAbandonedCartsVistos(lojaId) {
	localStorage.setItem(storageKey(lojaId), new Date().toISOString());
}
